module.exports = __webpack_public_path__ + "static/media/view6.c2712cca.jpg";